export default __webpack_public_path__ + "static/media/admin-page.651a4650.svg";